// extracted by mini-css-extract-plugin
export default {"outer":"styles_outer__RvHE-","inner":"styles_inner__oUjW+"};